let handlerTag = 1;
export function getNextHandlerTag() {
  return handlerTag++;
}
//# sourceMappingURL=getNextHandlerTag.js.map